import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import userReducer from "./user/user.reducer";
import snackbarReducer from "./snackbar/snackbar.reducer";
import companyReducer from "./company/company.reducer";
import memberReducer from "./member/member.reducer";
import harvesterReducer from "./harvester/harvester.reducer";
import harvestActivityReducer from "./harvest-activity/harvest-activity.reducer";
import blockReducer from "./block/block.reducer";
import activitiesCategoriesReducer from "./activities-categories/activities-categories.reducer";
import activitiesTypeReducer from "./activities-type/activities-type.reducer";
import taksasiActivityReducer from "./taksasi-activity/taksasi-activity.reducer";
import mutuAncakActivityReducer from "./mutu-ancak-activity/mutu-ancak-activity.reducer";
import estateReducer from "./estate/estate.reducer";
import mapsReducer from "./maps/maps.reducer";
import afdelingReducer from "./afdeling/afdeling.reducer";
import vehicleTypeReducer from "./vehicle-type/vehicle-type.reducer";
import vehicleReducer from "./vehicle/vehicle.reducer";
import monthlyActivityPlanReducer from "./monthly-activity-plan/monthly-activity-plan.reducer";
import loggingAngkutReducer from "./logging-angkut/logging-angkut.reducer";
import QCReducer from "./wood-qc/wood-qc.reducer";
import routeReducer from "./route-planning/route-planning.reducer";
import woodlogCountingReducer from "./woodlog-counting/woodlog-counting.reducer";
import PlanterReducer from "./planter/planter.reducer";
import CubicReducer from "./wood-cubic/wood-cubic.reducer";

const persistConfig = {
	key: "root",
	storage,
	blacklist: [
		"semaiUser",
		"snackbar",
		"joinRequest",
		"company",
		"member",
		"harvester",
		"harvestActivity",
		"block",
		"activitiesCategories",
		"activitiesType",
		"taksasiActivity",
		"mutuAncakActivity",
		"estate",
		"maps",
		"mapsPopUp",
		"afdeling",
		"vehicleType",
		"vehicle",
		"monthlyActivityPlan",
		"loggingAngkut",
		"QC",
		"activitiesPlan",
		"routePlan",
		"woodlogCounting",
		"planter",
		"cubic"
	],
};

const userPersistConfig = {
	key: "semaiUser",
	storage,
	whitelist: ["currentUser", "token", "provider", "refreshToken", "idToken"],
};

const rootReducer = combineReducers({
	semaiUser: persistReducer(userPersistConfig, userReducer),
	snackbar: snackbarReducer,
	company: companyReducer,
	member: memberReducer,
	activitiesCategories: activitiesCategoriesReducer,
	activitiesType: activitiesTypeReducer,
	harvester: harvesterReducer,
	harvestActivity: harvestActivityReducer,
	block: blockReducer,
	taksasiActivity: taksasiActivityReducer,
	mutuAncakActivity: mutuAncakActivityReducer,
	afdeling : afdelingReducer,
	estate: estateReducer,
	maps: mapsReducer,
	vehicleType: vehicleTypeReducer,
	vehicle: vehicleReducer,
	monthlyActivityPlan: monthlyActivityPlanReducer,
	loggingAngkut: loggingAngkutReducer,
	QC: QCReducer,
	routePlan: routeReducer,
	routePlan: routeReducer,
	woodlogCounting: woodlogCountingReducer,
	planter : PlanterReducer,
	cubic: CubicReducer,
});

export default persistReducer(persistConfig, rootReducer);
